import { JobOpening, Language } from '../types';
import Card from './ui/Card';
import Button from './ui/Button';

interface CareersProps {
  jobs: JobOpening[];
  language: Language;
  t: {
    title: string;
    subtitle: string;
    applyNow: string;
    noJobs: string;
  }
}

const BriefcaseIcon = ({ className }: { className?: string }) => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className={className}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M20.25 14.15v4.07a2.25 2.25 0 01-2.25 2.25H5.92a2.25 2.25 0 01-2.25-2.25v-4.07m16.5 0a2.25 2.25 0 00-2.25-2.25H5.92a2.25 2.25 0 00-2.25 2.25m16.5 0v-2.07a2.25 2.25 0 00-2.25-2.25H5.92a2.25 2.25 0 00-2.25 2.25v2.07m16.5 0v-2.07a2.25 2.25 0 00-2.25-2.25H5.92a2.25 2.25 0 00-2.25 2.25v2.07" />
    </svg>
);


const Careers = ({ jobs, language, t }: CareersProps) => {
  const activeJobs = jobs.filter(job => !job.isPaused);

  return (
    <section id="careers" className="py-16 sm:py-24">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl font-black text-white">{t.title}</h2>
          <p className="mt-4 text-lg text-slate-400 max-w-3xl mx-auto">
            {t.subtitle}
          </p>
        </div>
        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {activeJobs.length > 0 ? (
            activeJobs.map((job) => (
              <Card key={job.id} className="flex flex-col">
                <div className="flex-grow">
                  <div className="flex items-center mb-4">
                      <BriefcaseIcon className="w-6 h-6 text-green-400 mr-3"/>
                      <h3 className="text-xl font-bold text-white">{typeof job.title === 'string' ? job.title : ((job.title as any)?.[language] || (job.title as any)?.['es'] || '')}</h3>
                  </div>
                  <div className="flex items-center text-sm text-slate-400 mb-4">
                    <span>{typeof job.location === 'string' ? job.location : ((job.location as any)?.[language] || (job.location as any)?.['es'] || '')}</span>
                    <span className="mx-2">&bull;</span>
                    <span>{typeof job.type === 'string' ? job.type : ((job.type as any)?.[language] || (job.type as any)?.['es'] || '')}</span>
                  </div>
                  <p className="text-slate-300">{typeof job.description === 'string' ? job.description : ((job.description as any)?.[language] || (job.description as any)?.['es'] || '')}</p>
                </div>
                <div className="mt-6">
                  <Button 
                      variant="secondary" 
                      className="w-full"
                      onClick={() => window.location.href = `mailto:hr@negolan.com?subject=${encodeURIComponent('Application for ' + (typeof job.title === 'string' ? job.title : (job.title as any)?.['en'] || (job.title as any)?.['es'] || ''))}`}
                  >
                    {t.applyNow}
                  </Button>
                </div>
              </Card>
            ))
          ) : (
            <div className="col-span-full text-center">
                <p className="text-slate-400">{t.noJobs}</p>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default Careers;